// Generated by scripts/copy-dotlottie-assets.ts from the installed
// @lottiefiles/dotlottie-web version. Do not edit by hand.
export const DOTLOTTIE_ASSET_VERSION = '0.81.0';
